import React, { createContext, useState, useContext } from 'react';

// Create the context
const GlobalStateContext = createContext();

// Create a provider component
export const GlobalStateProvider = ({ children }) => {
  const [currState, setCurrState] = useState('GBP');

  const updateState = (newState) => {
    setCurrState(newState);
  };

  return (
    <GlobalStateContext.Provider value={{ currState, updateState }}>
      {children}
    </GlobalStateContext.Provider>
  );
};


// Custom hook to access the global state
export const useGlobalState = () => {

  const context = useContext(GlobalStateContext);
  if (!context) {
    throw new Error("useGlobalState must be used within a GlobalStateProvider");
  }
  return context;
};